import type { InstrumentationBus } from "@/core/instrumentation/bus/bus";
import type { InstrumentationEventMap } from "@/core/instrumentation/instrumentation.types";

/**
 * The page's ONE live bus, held at module level so non-React publishers
 * (`analytics/telemetry`) and diagnostics can reach it from anywhere. The
 * composition root sets it right after construction and releases it from its
 * cleanup; `null` means nothing to publish to (server render, before the
 * root's effect, after unmount) and every publisher treats that as silence.
 *
 * Stored under the core map and read back under the caller's: the root is
 * the one place that builds the bus, and it builds it with the app's full
 * vocabulary, so a publisher asking for a wider map is asking for what was
 * actually constructed. The cast is confined to this seam.
 */
let active: InstrumentationBus<InstrumentationEventMap> | null = null;

export const setActiveBus = <TEvents extends InstrumentationEventMap>(
  bus: InstrumentationBus<TEvents> | null,
): void => {
  active = bus as InstrumentationBus<InstrumentationEventMap> | null;
};

export const getActiveBus = <
  TEvents extends InstrumentationEventMap = InstrumentationEventMap,
>(): InstrumentationBus<TEvents> | null => active as InstrumentationBus<TEvents> | null;
